import { CUSTOMER_TICKET_STAGES, getCustomerTicketStages } from '../../utils/customerTicketStatus';

const GREEN_STYLE = { color: '#166534', bg: '#f0fdf4', border: '#bbf7d0', dot: '#71A95B' };
const NAVY_STYLE = { color: '#233A7A', bg: '#EDF3FC', border: '#B7C9EC', dot: '#29AAE1' };

const STATE_STYLE = { done: GREEN_STYLE, pending: NAVY_STYLE };

// Every stage the ticket has reached (past or current) is green; anything
// still ahead of it stays navy - no separate in-between "current" color.
function stageState(key, stages) {
  return stages[key] ? 'done' : 'pending';
}

/** Four-step progress for customer ticket views (list + detail). */
export default function CustomerTicketProgress({ ticket, compact = false }) {
  const stages = getCustomerTicketStages(ticket);

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: compact ? 6 : 8,
        alignItems: 'center',
      }}
      aria-label="وضعیت پیگیری تیکت"
    >
      {CUSTOMER_TICKET_STAGES.map((step, i) => {
        const state = stageState(step.key, stages);
        const style = STATE_STYLE[state];
        return (
          <div key={step.key} style={{ display: 'flex', alignItems: 'center', gap: compact ? 4 : 6 }}>
            {i > 0 && (
              <span style={{ color: '#cbd5e1', fontSize: compact ? 10 : 12, marginLeft: compact ? 2 : 4 }}>←</span>
            )}
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 5,
                fontSize: compact ? 10 : 12,
                fontWeight: state === 'pending' ? 500 : 700,
                color: style.color,
                background: style.bg,
                border: `1px solid ${style.border}`,
                borderRadius: 20,
                padding: compact ? '2px 8px' : '4px 10px',
                whiteSpace: 'nowrap',
              }}
            >
              <span
                style={{
                  width: compact ? 6 : 8,
                  height: compact ? 6 : 8,
                  borderRadius: '50%',
                  background: style.dot,
                  flexShrink: 0,
                }}
              />
              {step.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
